"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("./");

class Person {
  static thaw(personObj) {
    if (personObj == null) return null;
    const person = new Person();
    if (personObj.id != null) person.setId(personObj.id);
    if (personObj.firstName != null) person.setFirstName(personObj.firstName);
    if (personObj.lastName != null) person.setLastName(personObj.lastName);
    if (personObj.email != null) person.setEmail(personObj.email);
    if (personObj.phoneNumber != null) person.setPhoneNumber(personObj.phoneNumber);
    if (personObj.hash != null) person.setHash(personObj.hash);
    if (personObj.gender != null) person.setGender(personObj.gender);
    if (personObj.suspended != null) person.setSuspended(personObj.suspended == null ? null : personObj.suspended ? true : false);
    if (personObj.emergencyContact1Id != null) person.setEmergencyContact1Id(personObj.emergencyContact1Id);
    if (personObj.emergencyContact2Id != null) person.setEmergencyContact2Id(personObj.emergencyContact2Id);
    if (personObj.mailingAddressId != null) person.setMailingAddressId(personObj.mailingAddressId);
    if (personObj.emergencyContact1 != null) person.setEmergencyContact1(_.EmergencyContact.thaw(personObj.emergencyContact1));
    if (personObj.emergencyContact2 != null) person.setEmergencyContact2(_.EmergencyContact.thaw(personObj.emergencyContact2));
    if (personObj.mailingAddress != null) person.setMailingAddress(_.Address.thaw(personObj.mailingAddress));
    if (personObj.groupAssociations != null) person.setGroupAssociations(_.GroupAssociation.thawList(personObj.groupAssociations));
    if (personObj.transactions != null) person.setTransactions(_.Transaction.thawList(personObj.transactions));
    if (personObj.purchasedErgonars != null) person.setPurchasedErgonars(_.Ergonar.thawList(personObj.purchasedErgonars));
    if (personObj.evaluations != null) person.setEvaluations(_.Evaluation.thawList(personObj.evaluations));
    if (personObj.evaluator != null) person.setEvaluator(_.Evaluator.thaw(personObj.evaluator));
    if (personObj.guardians != null) person.setGuardians(Person.thawList(personObj.guardians));
    if (personObj.guardianBeneficiaries != null) person.setGuardianBeneficiaries(Person.thawList(personObj.guardianBeneficiaries));
    if (personObj.interestedParties != null) person.setInterestedParties(Person.thawList(personObj.interestedParties));
    if (personObj.interestedPartyBeneficiaries != null) person.setInterestedPartyBeneficiaries(Person.thawList(personObj.interestedPartyBeneficiaries));
    if (personObj.languages != null) person.setLanguages(_.Language.thawList(personObj.languages));
    if (personObj.isAdmin != null) person.setIsAdmin(personObj.isAdmin);
    if (personObj.stripeCustomerId != null) person.setStripeCustomerId(personObj.stripeCustomerId);
    if (personObj.evaluatorInterest != null) person.setEvaluatorInterest(personObj.evaluatorInterest);
    if (personObj.emailVerified != null) person.setEmailVerified(personObj.emailVerified);
    if (personObj.lastLoggedInTimeStamp != null) person.setLastLoggedInTimestamp(personObj.lastLoggedInTimeStamp);
    if (personObj.twoFactorSetupRequired != null) person.setTwoFactorSetupRequired(personObj.twoFactorSetupRequired ? true : false);
    if (personObj.twoFactorType != null) person.setTwoFactorType(personObj.twoFactorType);
    if (personObj.createdAt != null) person.setCreatedAt(personObj.createdAt);
    if (personObj.heardAboutFrom != null) person.setHeardAboutFrom(personObj.heardAboutFrom);
    return person;
  }

  static thawList(personObjList) {
    if (personObjList == null) return [];
    var persons = [];

    for (var i = 0; i < personObjList.length; i++) {
      persons.push(Person.thaw(personObjList[i]));
    }

    return persons;
  }

  static freeze(person) {
    if (person == null) return null;
    var personObj = {};
    if (person.getId() != null) personObj.id = person.getId();
    if (person.getFirstName() != null) personObj.firstName = person.getFirstName();
    if (person.getLastName() != null) personObj.lastName = person.getLastName();
    if (person.getEmail() != null) personObj.email = person.getEmail();
    if (person.getPhoneNumber() != null) personObj.phoneNumber = person.getPhoneNumber();
    if (person.getHash() != null) personObj.hash = person.getHash();
    if (person.getGender() != null) personObj.gender = person.getGender();
    if (person.getSuspended() != null) personObj.suspended = person.getSuspended() == null ? null : person.getSuspended() ? 1 : 0;
    if (person.getEmergencyContact1Id() != null) personObj.emergencyContact1Id = person.getEmergencyContact1Id();
    if (person.getEmergencyContact2Id() != null) personObj.emergencyContact2Id = person.getEmergencyContact2Id();
    if (person.getMailingAddressId() != null) personObj.mailingAddressId = person.getMailingAddressId();
    if (person.getEmergencyContact1() != null) personObj.emergencyContact1 = _.EmergencyContact.freeze(person.getEmergencyContact1());
    if (person.getEmergencyContact2() != null) personObj.emergencyContact2 = _.EmergencyContact.freeze(person.getEmergencyContact2());
    if (person.getMailingAddress() != null) personObj.mailingAddress = _.Address.freeze(person.getMailingAddress());
    if (person.getGroupAssociations() != null) personObj.groupAssociations = _.GroupAssociation.freezeList(person.getGroupAssociations());
    if (person.getTransactions() != null) personObj.transactions = _.Transaction.freezeList(person.getTransactions());
    if (person.getPurchasedErgonars() != null) personObj.purchasedErgonars = _.Ergonar.freezeList(person.getPurchasedErgonars());
    if (person.getEvaluations() != null) personObj.evaluations = _.Evaluation.freezeList(person.getEvaluations());
    if (person.getEvaluator() != null) personObj.evaluator = _.Evaluator.freeze(person.getEvaluator());
    if (person.getGuardians() != null) personObj.guardians = Person.freezeList(person.getGuardians());
    if (person.getGuardianBeneficiaries() != null) personObj.guardianBeneficiaries = Person.freezeList(person.getGuardianBeneficiaries());
    if (person.getInterestedParties() != null) personObj.interestedParties = Person.freezeList(person.getInterestedParties());
    if (person.getInterestedPartyBeneficiaries() != null) personObj.interestedPartyBeneficiaries = Person.freezeList(person.getInterestedPartyBeneficiaries());
    if (person.getLanguages() != null) personObj.languages = _.Language.freezeList(person.getLanguages());
    if (person.getIsAdmin() != null) personObj.isAdmin = person.getIsAdmin();
    if (person.getStripeCustomerId() != null) personObj.stripeCustomerId = person.getStripeCustomerId();
    if (person.getEvaluatorInterest() != null) personObj.evaluatorInterest = person.getEvaluatorInterest();
    if (person.getEmailVerified() != null) personObj.emailVerified = person.getEmailVerified();
    if (person.getLastLoggedInTimestamp() != null) personObj.lastLoggedInTimeStamp = person.getLastLoggedInTimestamp();
    if (person.getTwoFactorSetupRequired() != null) personObj.twoFactorSetupRequired = person.getTwoFactorSetupRequired() ? 1 : 0;
    if (person.getTwoFactorType() != null) personObj.twoFactorType = person.getTwoFactorType();
    if (person.getCreatedAt() != null) personObj.createdAt = person.getCreatedAt();
    if (person.getHeardAboutFrom() != null) personObj.heardAboutFrom = person.getHeardAboutFrom();
    return personObj;
  }

  static freezeList(persons) {
    if (persons == null) return [];
    var personObjList = [];

    for (var i = 0; i < persons.length; i++) {
      personObjList.push(Person.freeze(persons[i]));
    }

    return personObjList;
  }

  constructor() {
    this.setId(null);
    this.setFirstName(null);
    this.setLastName(null);
    this.setEmail(null);
    this.setPhoneNumber(null);
    this.setHash(null);
    this.setGender(null);
    this.setSuspended(null);
    this.setEmergencyContact1Id(null);
    this.setEmergencyContact2Id(null);
    this.setMailingAddressId(null);
    this.setEmergencyContact1(null);
    this.setEmergencyContact2(null);
    this.setMailingAddress(null);
    this.setGroupAssociations(null);
    this.setTransactions(null);
    this.setPurchasedErgonars(null);
    this.setEvaluations(null);
    this.setEvaluator(null);
    this.setGuardians(null);
    this.setGuardianBeneficiaries(null);
    this.setInterestedParties(null);
    this.setInterestedPartyBeneficiaries(null);
    this.setLanguages(null);
    this.setIsAdmin(null);
    this.setStripeCustomerId(null);
    this.setEvaluatorInterest(null);
    this.setEmailVerified(null);
    this.setLastLoggedInTimestamp(null);
    this.setTwoFactorSetupRequired(null);
    this.setTwoFactorType(null);
    this.setCreatedAt(null);
    this.setHeardAboutFrom(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setFirstName(firstName) {
    this.firstName = firstName;
  }

  setLastName(lastName) {
    this.lastName = lastName;
  }

  setEmail(email) {
    this.email = email;
  }

  setPhoneNumber(phoneNumber) {
    this.phoneNumber = phoneNumber;
  }

  setHash(hash) {
    this.hash = hash;
  }

  setGender(gender) {
    this.gender = gender;
  }

  setSuspended(suspended) {
    this.suspended = suspended;
  }

  setEmergencyContact1Id(emergencyContact1Id) {
    this.emergencyContact1Id = emergencyContact1Id;
  }

  setEmergencyContact2Id(emergencyContact2Id) {
    this.emergencyContact2Id = emergencyContact2Id;
  }

  setMailingAddressId(mailingAddressId) {
    this.mailingAddressId = mailingAddressId;
  }

  setEmergencyContact1(emergencyContact1) {
    this.emergencyContact1 = emergencyContact1;
  }

  setEmergencyContact2(emergencyContact2) {
    this.emergencyContact2 = emergencyContact2;
  }

  setMailingAddress(mailingAddress) {
    this.mailingAddress = mailingAddress;
  }

  setGroupAssociations(groupAssociations) {
    this.groupAssociations = groupAssociations;
  }

  setTransactions(transactions) {
    this.transactions = transactions;
  }

  setPurchasedErgonars(purchasedErgonars) {
    this.purchasedErgonars = purchasedErgonars;
  }

  setEvaluations(evaluations) {
    this.evaluations = evaluations;
  }

  setEvaluator(evaluator) {
    this.evaluator = evaluator;
  }

  setGuardians(guardians) {
    this.guardians = guardians;
  }

  setGuardianBeneficiaries(guardianBeneficiaries) {
    this.guardianBeneficiaries = guardianBeneficiaries;
  }

  setInterestedParties(interestedParties) {
    this.interestedParties = interestedParties;
  }

  setInterestedPartyBeneficiaries(interestedPartyBeneficiaries) {
    this.interestedPartyBeneficiaries = interestedPartyBeneficiaries;
  }

  setLanguages(languages) {
    this.languages = languages;
  }

  setIsAdmin(isAdmin) {
    this.isAdmin = isAdmin;
  }

  setStripeCustomerId(stripeCustomerId) {
    this.stripeCustomerId = stripeCustomerId;
  }

  setEvaluatorInterest(evaluatorInterest) {
    this.evaluatorInterest = evaluatorInterest;
  }

  setEmailVerified(emailVerified) {
    this.emailVerified = emailVerified;
  }

  setLastLoggedInTimestamp(lastLoggedInTimeStamp) {
    this.lastLoggedInTimeStamp = lastLoggedInTimeStamp;
  }

  setTwoFactorSetupRequired(twoFactorSetupRequired) {
    this.twoFactorSetupRequired = twoFactorSetupRequired;
  }

  setTwoFactorType(twoFactorType) {
    this.twoFactorType = twoFactorType;
  }

  setCreatedAt(createdAt) {
    this.createdAt = createdAt;
  }

  setHeardAboutFrom(heardAboutFrom) {
    this.heardAboutFrom = heardAboutFrom;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getFirstName() {
    return this.firstName;
  }

  getLastName() {
    return this.lastName;
  }

  getEmail() {
    return this.email;
  }

  getPhoneNumber() {
    return this.phoneNumber;
  }

  getHash() {
    return this.hash;
  }

  getGender() {
    return this.gender;
  }

  getSuspended() {
    return this.suspended;
  }

  getEmergencyContact1Id() {
    return this.emergencyContact1Id;
  }

  getEmergencyContact2Id() {
    return this.emergencyContact2Id;
  }

  getMailingAddressId() {
    return this.mailingAddressId;
  }

  getEmergencyContact1() {
    return this.emergencyContact1;
  }

  getEmergencyContact2() {
    return this.emergencyContact2;
  }

  getMailingAddress() {
    return this.mailingAddress;
  }

  getGroupAssociations() {
    return this.groupAssociations;
  }

  getTransactions() {
    return this.transactions;
  }

  getPurchasedErgonars() {
    return this.purchasedErgonars;
  }

  getEvaluations() {
    return this.evaluations;
  }

  getEvaluator() {
    return this.evaluator;
  }

  getGuardians() {
    return this.guardians;
  }

  getGuardianBeneficiaries() {
    return this.guardianBeneficiaries;
  }

  getInterestedParties() {
    return this.interestedParties;
  }

  getInterestedPartyBeneficiaries() {
    return this.interestedPartyBeneficiaries;
  }

  getLanguages() {
    return this.languages;
  }

  getIsAdmin() {
    return this.isAdmin;
  }

  getStripeCustomerId() {
    return this.stripeCustomerId;
  }

  getEvaluatorInterest() {
    return this.evaluatorInterest;
  }

  getEmailVerified() {
    return this.emailVerified;
  }

  getLastLoggedInTimestamp() {
    return this.lastLoggedInTimeStamp;
  }

  getTwoFactorSetupRequired() {
    return this.twoFactorSetupRequired;
  }

  getTwoFactorType() {
    return this.twoFactorType;
  }

  getCreatedAt() {
    return this.createdAt;
  }

  getHeardAboutFrom() {
    return this.heardAboutFrom;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


  getFullName() {
    if (this.firstName != null && this.lastName != null) return this.firstName + ' ' + this.lastName;else if (this.firstName != null) return this.firstName;else if (this.lastName != null) return this.lastName;
    return null;
  }

}

exports.default = Person;